module.exports = __webpack_public_path__ + "static/media/bed_new_pack_dog_FR_768x290.ee9de307.png";